import { Level2Wrapper } from '../common/Level2Wrapper';
import { GenericSubSection } from '../common/GenericSubSection';
import { usePowerEquipmentSection } from '../../hooks/usePowerEquipmentSection';

export const PowerEquipment = () => {
  const section = usePowerEquipmentSection();
  if (!section) return null;

  return (
    <Level2Wrapper label="Power Equipment Checked">
      <GenericSubSection section={section} />
    </Level2Wrapper>
  );
};
